export default __webpack_public_path__ + "static/media/ford.749274d5.jpg";